const USER_KEY = 'aceb_user';

export function getUserEmail(): string | undefined {
  if (typeof window === 'undefined') return undefined;

  try {
    const stored = localStorage.getItem(USER_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.email) return parsed.email;
    }
  } catch { /* ignore parse errors */ }

  return localStorage.getItem('userEmail') || undefined;
}
